import { useBrandingStore } from '../store/brandingStore';

/** Shipped default mark; used when no custom logo is configured. */
const DEFAULT_LOGO = '/brand/c1-logo.png';

/**
 * TeamOne mark.
 *
 * The image source is driven by the organization branding store
 * (`logoUrl`, configurable in Admin → Organization → Branding). When no custom
 * logo is set it falls back to the shipped default mark.
 *
 * `isDark` means "rendered on a saturated / dark surface" (e.g. the auth
 * gradient panel) — the wordmark switches to white so it stays legible
 * regardless of the active theme.
 */
export function Logo({
  className = 'w-8 h-8',
  showText = true,
  isDark = false,
}: {
  className?: string;
  showText?: boolean;
  isDark?: boolean;
}) {
  const logoUrl = useBrandingStore((s) => s.logoUrl);
  const appName = useBrandingStore((s) => s.appName);
  const tagline = useBrandingStore((s) => s.tagline);
  const src = logoUrl && logoUrl.trim() ? logoUrl : DEFAULT_LOGO;
  const name = appName && appName.trim() ? appName.trim() : 'TeamOne';
  const sub = tagline && tagline.trim() ? tagline.trim() : 'Business Platform';
  return (
    <div className={`flex items-center gap-3 select-none ${className}`}>
      <img
        src={src}
        alt="TeamOne"
        className="aspect-square h-full w-auto shrink-0 object-contain"
      />
      {showText && (
        <>
          <div className={`h-8 w-px ${isDark ? 'bg-white/25' : 'bg-border'}`} />
          <div className="flex flex-col justify-center text-left">
            <span
              className={`font-display text-xl font-semibold leading-none tracking-tight ${
                isDark ? 'text-white' : 'text-foreground'
              }`}
            >
              {name}
            </span>
            <span
              className={`mt-0.5 text-overline ${
                isDark ? 'text-white/60' : 'text-text-tertiary'
              }`}
            >
              {sub}
            </span>
          </div>
        </>
      )}
    </div>
  );
}
